import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem } from "@sprout/list-navigation/dist/Menu";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ItemType } from "sprout-graphql";
import { ShareOutlined } from "sprout-ui-icons";
const MenuItemShare = (props)=>{
    const { type  } = props;
    const [share, setShare] = useState(false);
    useEffect(()=>{
        if (typeof navigator.share !== "undefined") setShare(true);
    }, []);
    const display = useMemo(()=>{
        if (typeof type === "string") return type;
        if (!type) return undefined;
        switch(type){
            case ItemType.Post:
                return "leaf";
            case ItemType.Topic:
                return "tree";
            case ItemType.ChecklistItem:
                return "to-do";
            case ItemType.Checklist:
                return "to-do list";
            default:
                return undefined;
        }
    }, [
        type
    ]);
    const handleClick = useCallback(()=>{
        navigator.share({
            text: document.title,
            url: window.location.href
        });
    }, []);
    if (!share) return null;
    return /*#__PURE__*/ _jsx(MenuItem, {
        label: display ? `Share ${display} via...` : "Share via...",
        icon: ShareOutlined,
        onClick: handleClick
    });
};
export default MenuItemShare;
